import { Observer } from 'mobx-react-lite';
import React from 'react';
import { Primary } from '../../constants/color.enum';
import { getContextColorStyle } from '../../utils/colors.utils';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import './LoadingIndicatorSection.scss';
var LoadingIndicatorSection = function (p) {
    return React.createElement(Observer, { children: function () {
            var _a;
            return (React.createElement("div", { className: "LoadingIndicatorSection", "data-cy": p.dataCy, "data-colored": (_a = p.colored) !== null && _a !== void 0 ? _a : true, style: getContextColorStyle(Primary, p.color) }, p.hasReachedEnd ? p.reachedEndText : React.createElement(LoadingIndicator, null)));
        } });
};
export default LoadingIndicatorSection;
